module.exports = __webpack_public_path__ + "static/media/image-polaroid.6b32ddfb.svg";